<wms-dialog id="createMRModal" customClasses="small create-mr-dialog" [content]="createMRModal"></wms-dialog>
<ng-template #createMRModal let-branchName="pushBranchName" let-remoteTackingBranchName="remoteTrackingBranchName">
  <wms-dialog-header (onClose)="dialogService.close('createMRModal')" customClass="pullChanges-header"
                     title="{{locale['TITLE_MERGE_REQUEST_' + projectService.teamProjectObject.vcsAccountDTO.vcsAccountType] || locale.TITLE_MERGE_REQUEST_DEFAULT}}"></wms-dialog-header>
  <wms-dialog-body>
    <p>
      {{locale.MSG_CHANGES_PUSHED_TO_BRANCH}}
      <span class="branch-name">
        {{branchName}}
        <button class="btn btn-transparent" (click)="copyToClipboard(branchName)" container="body" placement="right" tooltip="{{locale.ICONTITLE_COPY_CLIPBOARD}}">
          <i class="wm-icon fa fa-copy"></i>
        </button>
      </span>
    </p>
    <p>
      {{locale['MSG_CREATE_MERGE_REQUEST_' + projectService.teamProjectObject.vcsAccountDTO.vcsAccountType] || locale.MSG_CREATE_MERGE_REQUEST_DEFAULT}}
      <strong>{{remoteTackingBranchName}}</strong>
    </p>
    <p class="help" [innerHTML]="locale['MSG_MERGE_REQUEST_NOTE_' + projectService.teamProjectObject.vcsAccountDTO.vcsAccountType] || locale.MSG_MERGE_REQUEST_NOTE_DEFAULT"></p>
  </wms-dialog-body>
  <wms-dialog-footer>
    <a target="_blank" class="btn button-primary app-button"
       [href]="projectService.teamProjectObject.createMrLink">{{locale.LABEL_PROCEED}}</a>
  </wms-dialog-footer>
</ng-template>

